<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card>
        <v-card-title>LOGIN</v-card-title>
        <v-card-text>
          <v-form v-model="valid" ref="form" @submit.prevent="onSubmit">
            <v-text-field
              v-model="id"
              label="ID"
              prepend-icon="mdi-face"
              append-icon="mdi-eye"
              :rules="[v => !!v || 'ID를 입력하세요']"
              required
            ></v-text-field>
            <v-text-field
              type="password"
              v-model="password"
              label="PASSWORD"
              prepend-icon="mdi-lock"
              append-icon="mdi-eye-off"
              :rules="[v => !!v || 'password를 입력하세요']"
              required
            ></v-text-field>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="deep-purple" text>Submit</v-btn>
              <v-btn type="submit" color="deep-purple" text @click="login"
                >시놀로지 로그인</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// import SYNOSSO from "https://n.devmon.kr:5001/webman/sso/synoSSO-1.0.0.js";
import SYNOSSO from "@/util/synosso";
// import { login } from "@/api/common";

export default {
  data() {
    return {
      valid: true,
      id: "",
      password: "",
      show: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      SYNOSSO.init({
        oauthserver_url: "https://n.devmon.kr:5001",
        app_id: "4cdeae9ed7753a890719ab194749ab94",
        redirect_uri: "https://intra.devmon.kr/",
        callback: this.authCallback,
      });
    },
    async authCallback(response) {
      alert(response.status);
      alert(response.access_token);
      if ("not_login" === response.status) {
        //user not login
      } else if ("login" === response.status) {
        try {
          console.log(response);
          // const res = await login(response.access_token);
          // console.log(res);
          // // if(res.success){
          // //   this.$router.push(response.url);
          // // }
        } catch (error) {
          console.log(error);
        }

        // $.ajax({
        //   url: "/partner/result",
        //   cache: false,
        //   type: "GET",
        //   dataType: "json",
        //   data: { accesstoken: response.access_token },
        //   error: function(xhr) {
        //     console.log("ajax error");
        //   },
        //   success: function(response) {
        //     if (response.success === true)
        //       document.location.replace(response.url);
        //     else
        //       document.location.replace("http://localhost:8080/partner/test");
        //   },
        // });
      } else {
        console.log("error");
      }
    },
    login() {
      SYNOSSO.login();
    },
    onSubmit() {
      // this.$refs.form.validate();
      // if (!this.valid) return false;
      // console.log(this.id, this.password);
    },
  },
};
</script>

<style></style>
